// extracted by mini-css-extract-plugin
export default {"panel":"xSsEPGI3a0LeaXpMk7aA"};